var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"vapp"}},[_c('v-main',[_c('router-view'),_c('LoadingView',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }